var exports = {
  "kL": "InlineAudioPlayer.module__container___ZGVic2",
  "wx": "InlineAudioPlayer.module__header___ZGVic2",
  "Rr": "InlineAudioPlayer.module__playButton___ZGVic2",
  "CJ": "InlineAudioPlayer.module__playButtonIcon___ZGVic2",
  "sp": "InlineAudioPlayer.module__loadingSpinnerDesktop___ZGVic2",
  "XE": "InlineAudioPlayer.module__fileInfo___ZGVic2",
  "Md": "InlineAudioPlayer.module__fileName___ZGVic2",
  "m$": "InlineAudioPlayer.module__fileNameTruncate___ZGVic2",
  "i_": "InlineAudioPlayer.module__fileExtension___ZGVic2",
  "gM": "InlineAudioPlayer.module__fileMeta___ZGVic2",
  "NE": "InlineAudioPlayer.module__progressSection___ZGVic2",
  "hr": "InlineAudioPlayer.module__progressBar___ZGVic2",
  "Td": "InlineAudioPlayer.module__time___ZGVic2",
  "ne": "InlineAudioPlayer.module__controls___ZGVic2",
  "it": "InlineAudioPlayer.module__controlsLeft___ZGVic2",
  "BT": "InlineAudioPlayer.module__controlsRight___ZGVic2",
  "Wq": "InlineAudioPlayer.module__volumeControl___ZGVic2",
  "hP": "InlineAudioPlayer.module__actionButton___ZGVic2",
  "AA": "InlineAudioPlayer.module__mobileContainer___ZGVic2",
  "xk": "InlineAudioPlayer.module__mobilePlayButton___ZGVic2",
  "S": "InlineAudioPlayer.module__loadingSpinner___ZGVic2",
  "_S": "InlineAudioPlayer.module__mobileContainerActive___ZGVic2",
  "wh": "InlineAudioPlayer.module__mobileContent___ZGVic2",
  "Vg": "InlineAudioPlayer.module__mobileFileInfo___ZGVic2",
  "Yg": "InlineAudioPlayer.module__mobileFileName___ZGVic2",
  "kB": "InlineAudioPlayer.module__mobileFileMeta___ZGVic2",
  "hb": "InlineAudioPlayer.module__mobileProgressContainer___ZGVic2",
  "jw": "InlineAudioPlayer.module__mobileProgressTrack___ZGVic2",
  "lm": "InlineAudioPlayer.module__mobileProgressTrackActive___ZGVic2",
  "$r": "InlineAudioPlayer.module__mobileProgressFill___ZGVic2",
  "LI": "InlineAudioPlayer.module__mobileProgressFillActive___ZGVic2",
  "zr": "InlineAudioPlayer.module__mobileTimestamp___ZGVic2",
};

module.exports = exports;
